/**
 * Telegram Mini App: сайт, открытый кнопкой бота внутри Telegram.
 *
 * Скрипт Telegram грузим ТОЛЬКО когда нас открыли из Telegram (в адресе
 * `#tgWebAppData=…`), чтобы обычный сайт не тянул чужой JS. Дальше внутри
 * приложения адрес меняется, и метку держим в sessionStorage; сам скрипт
 * Telegram при перезагрузке берёт initData из своего sessionStorage.
 *
 * Вход: initData (подписан токеном бота) → /auth/telegram/webapp, см.
 * backend auth.telegram_webapp_login.
 */
const KEY = 'sb_tgwa';
const SRC = 'https://telegram.org/js/telegram-web-app.js';

declare global {
  interface Window { Telegram?: { WebApp?: any } }
}

function launched(): boolean {
  if (/tgWebAppData=/.test(window.location.hash)) return true;
  try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; }
}

/** WebApp-объект Telegram, если мы внутри Mini App и данные есть. */
export function tgWebApp(): any | null {
  const wa = window.Telegram?.WebApp;
  return wa && wa.initData ? wa : null;
}

export const isTelegramWebApp = (): boolean => !!tgWebApp();

export const tgInitData = (): string | null => tgWebApp()?.initData || null;

function loadScript(src: string, timeoutMs: number): Promise<void> {
  return new Promise(res => {
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    const t = setTimeout(res, timeoutMs);
    s.onload = () => { clearTimeout(t); res(); };
    s.onerror = () => { clearTimeout(t); res(); };
    document.head.appendChild(s);
  });
}

/** Вызывается до первого рендера. Вне Telegram — сразу выходит. */
export async function bootTelegram(): Promise<void> {
  if (!launched()) return;
  try { sessionStorage.setItem(KEY, '1'); } catch { /* приватный режим */ }
  await loadScript(SRC, 4000);
  const wa = window.Telegram?.WebApp;
  if (!wa) return;
  try {
    wa.ready();
    wa.expand();
    wa.setHeaderColor?.('#0a0a0a');
    wa.setBackgroundColor?.('#0a0a0a');
  } catch { /* старый клиент Telegram — без оформления */ }
}
